import { usePreferredColorScheme } from "@reactuses/core";

import { useAppTheme } from "@/core/lib/state-xstate";

export type Theme = "light" | "dark";

export const useTheme = (): Theme => {
  const theme = useAppTheme();
  const preference = usePreferredColorScheme();

  if (theme === "automatic") {
    if (preference === "light") return "light";
    return "dark";
  }

  return theme;
};
